import { createGlobalStyle } from 'styled-components';

export const fontFamily = {
  proximaVara: "'Proxima Vara', sans-serif, Helvetica, Arial, Verdana, Tahoma",
};

export const Fonts = {
  '--font-proxima-vara': fontFamily.proximaVara,
};

export const GlobalFonts = createGlobalStyle`
  @font-face {
    font-family: 'Proxima Vara';
    src: url('/static/fonts/ProximaVaraVariable.woff2') format('woff2');
    font-display: swap;
    font-style: normal;
    font-weight: 100 900;
    font-stretch: normal;
  }

  :root {
    ${Fonts}
  }

  body {
    font-family: var(--font-proxima-vara);
    color: var(--text-default);
  }
`;
